import ClickOutAlertWrapper from "../../wrappers/ClickOutAlertWrapper/ClickOutAlertWrapper";
import { useEffect, useRef, useState } from "react";

import "./MultiLineTextInputToggleField_style.css";

type Props = {
    label?: string | null | undefined;
    placeholderText?: string;
    displayFieldStyle?: React.CSSProperties | undefined;
    editorFieldStyle?: React.CSSProperties | undefined;
    isEditable?: boolean;
    value: string;
    onStopEditing?: (val: string) => void;
    numberOfLines?: number | null;
    numberOfEditLines?: number | null;
};

export default function MultiLineTextField({
    label,
    placeholderText,
    displayFieldStyle,
    editorFieldStyle,
    isEditable,
    value,
    onStopEditing,
    numberOfLines = null,
    numberOfEditLines = null,
}: Props): JSX.Element {
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [textValue, setTextValue] = useState<string>(value);

    const ref = useRef(null);

    const textRef = useRef<string>();
    textRef.current = textValue;

    useEffect(() => {
        if (!isEditing) {
            setTextValue(value);
        }
    }, [value]);

    return (
        <div
            ref={ref}
            className={`multi-line-text-input-toggle-field-container`}
        >
            {label != null && <div className="label">{label}</div>}
            {isEditing ? (
                <ClickOutAlertWrapper
                    forwardRef={ref}
                    onClickOut={() => {
                        setIsEditing(false);
                        if (textRef.current) {
                            onStopEditing?.(textRef.current);
                        }
                    }}
                >
                    <textarea
                        rows={numberOfLines ?? numberOfEditLines ?? undefined}
                        className={`editor-field`}
                        style={
                            numberOfLines == null && numberOfEditLines == null
                                ? editorFieldStyle
                                : { ...editorFieldStyle, resize: "none" }
                        }
                        value={textValue}
                        autoFocus
                        onChange={(e) => {
                            setTextValue(e.target.value);
                        }}
                        onBlur={() => {
                            setIsEditing(false);
                            onStopEditing?.(textValue);
                        }}
                    />
                </ClickOutAlertWrapper>
            ) : (
                <div
                    className={`display-field${
                        textValue.length === 0 ? ` placeholder` : ``
                    }${isEditable ? " editable" : ""}`}
                    style={
                        numberOfLines == null
                            ? displayFieldStyle
                            : {
                                  ...displayFieldStyle,
                                  maxHeight: `${numberOfLines * 1.25}em`,
                              }
                    }
                    onClick={() => {
                        if (isEditable) {
                            setIsEditing(true);
                        }
                    }}
                >
                    {textValue.length === 0 && placeholderText !== undefined
                        ? placeholderText
                        : textValue}
                </div>
            )}
        </div>
    );
}
